(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const shareButtons = document.querySelectorAll('.share-button');

    if (!shareButtons.length) return;

    shareButtons.forEach((button) => {
      button.addEventListener('click', async () => {
        const url = button.dataset.shareUrl || window.location.href;
        const title = button.dataset.shareTitle || document.title;

        if (navigator.share) {
          try {
            await navigator.share({ title, url });
          } catch (error) {
          }
          return;
        }

        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(url);
            showShareFeedback(button, 'Link copied');
          } else {
            legacyCopyToClipboard(url);
            showShareFeedback(button, 'Link copied');
          }
        } catch (error) {
          window.open(url, '_blank', 'noopener,noreferrer');
        }
      });
    });

    function showShareFeedback(button, message) {
      const originalText = button.textContent;
      button.textContent = message;
      button.disabled = true;

      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 1500);
    }

    function legacyCopyToClipboard(text) {
      const tempInput = document.createElement('input');
      tempInput.type = 'text';
      tempInput.value = text;
      tempInput.setAttribute('readonly', '');
      tempInput.style.position = 'absolute';
      tempInput.style.left = '-9999px';
      document.body.appendChild(tempInput);
      tempInput.select();
      try {
        document.execCommand('copy');
      } catch (e) {}
      document.body.removeChild(tempInput);
    }
  });


  document.addEventListener('DOMContentLoaded', () => {
  // Reset sticky add-to-cart button after tick animation
  const observer = new MutationObserver(() => {
    const addCartBtn = document.querySelector('.sticky-add-to-cart__button.add-cart-btn');
    if (!addCartBtn) return;

    addCartBtn.addEventListener('click', () => {
      // Wait for the tick animation to show, then revert
      setTimeout(() => {
        addCartBtn.classList.remove('added');
        addCartBtn.removeAttribute('data-added');

        // Also reset any inner state classes the theme might add
        const addedSpan = addCartBtn.querySelector('.add-to-cart__added');
        const textSpan  = addCartBtn.querySelector('.add-to-cart-text');

        if (addedSpan) addedSpan.style.display  = '';
        if (textSpan)  textSpan.style.display   = '';

        // Force revert display
        addCartBtn.style.removeProperty('--add-to-cart-state');
      }, 2500); // 2.5s — enough for tick to show, then revert
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
  const RECENTLY_VIEWED_STORAGE_KEY = 'recently_viewed_products_v1';

  function getRecentlyViewedHandles() {
    try {
      const raw = window.localStorage.getItem(RECENTLY_VIEWED_STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed;
    } catch (e) {
      return [];
    }
  }

  function saveRecentlyViewedHandle(handle, maxProducts) {
    if (!handle) return;

    const existing = getRecentlyViewedHandles().filter(function (item) {
      return item !== handle;
    });

    existing.unshift(handle);

    const limited = existing.slice(0, maxProducts);

    try {
      window.localStorage.setItem(RECENTLY_VIEWED_STORAGE_KEY, JSON.stringify(limited));
    } catch (e) {}
  }

  function fetchProductCardSection(handle, sectionId) {
    const url =
      '/products/' +
      encodeURIComponent(handle) +
      '?section_id=' +
      encodeURIComponent(sectionId);

    return fetch(url)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Network error for ' + url);
        }
        return response.text();
      })
      .then(function (html) {
        const container = document.createElement('div');
        container.innerHTML = html;

        // Shopify section render usually returns the section root as the first element.
        // We take its innerHTML as the card markup.
        const sectionRoot = container.firstElementChild;
        if (!sectionRoot) return '';

        return sectionRoot.innerHTML || '';
      })
      .catch(function () {
        return '';
      });
  }

  function hydrateRecentlyViewedSection(sectionEl) {
    if (!sectionEl) return;

    var wrapper = sectionEl.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    var emptyMessageId = 'recently-viewed-empty-message';
    var emptyMessageEl = sectionEl.querySelector('#' + emptyMessageId);

    var maxProducts = Number(sectionEl.dataset.maxProducts || 8);
    var currentHandle = sectionEl.dataset.productHandle;
    var productCardSectionId = sectionEl.dataset.productCardSectionId;

    var handles = getRecentlyViewedHandles()
      .filter(function (handle) {
        // Exclude current product from list
        return handle && handle !== currentHandle;
      })
      .slice(0, maxProducts);

    if (!handles.length) {
      if (!emptyMessageEl) {
        emptyMessageEl = document.createElement('p');
        emptyMessageEl.id = emptyMessageId;
        emptyMessageEl.className = 'recently-viewed-empty-message';
        emptyMessageEl.textContent = 'You have not viewed any products yet.';
        sectionEl.appendChild(emptyMessageEl);
      }
      emptyMessageEl.hidden = false;
      sectionEl.remove();
      return;
    }

    // Build an array of Promises to fetch each product card
    var fetchPromises = handles.map(function (handle) {
      return fetchProductCardSection(handle, productCardSectionId).then(function (cardHtml) {
        return {
          handle: handle,
          html: cardHtml
        };
      });
    });

    Promise.all(fetchPromises).then(function (results) {
      wrapper.innerHTML = '';

      results.forEach(function (result) {
        if (!result || !result.html) return;

        var slide = document.createElement('div');
        slide.className = 'swiper-slide';
        slide.innerHTML = result.html;

        wrapper.appendChild(slide);
      });

      if (!wrapper.children.length) {
        if (!emptyMessageEl) {
          emptyMessageEl = document.createElement('p');
          emptyMessageEl.id = emptyMessageId;
          emptyMessageEl.className = 'recently-viewed-empty-message';
          emptyMessageEl.textContent = 'You have not viewed any products yet.';
          sectionEl.appendChild(emptyMessageEl);
        }
        emptyMessageEl.hidden = false;
        sectionEl.remove()
      } else if (emptyMessageEl) {
        emptyMessageEl.hidden = true;
      }
      
      // If you initialize Swiper manually, you can re-init or update here if needed.

      const mainSwiper = document.getElementById('swiper-recently-viewed-products');
      if (!mainSwiper) return;
      if (mainSwiper.swiper) mainSwiper.swiper.destroy(true, true);

      new Swiper(mainSwiper, {
        slidesPerView: 2,           // Mobile pe 2 cards side by side
        spaceBetween: 12,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          480:  { slidesPerView: 2, spaceBetween: 15 },
          640:  { slidesPerView: 3, spaceBetween: 18 },
          768:  { slidesPerView: 3, spaceBetween: 20 },
          1024: { slidesPerView: 4, spaceBetween: 24 },
          1200: { slidesPerView: 4, spaceBetween: 19 }
        }
      });
      
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var sections = document.querySelectorAll('[data-recently-viewed="true"]');
    if (!sections.length) return;

    sections.forEach(function (sectionEl) {
      var maxProducts = Number(sectionEl.dataset.maxProducts || 8);
      var currentHandle = sectionEl.dataset.productHandle;

      // 1) Store current product handle in localStorage
      saveRecentlyViewedHandle(currentHandle, maxProducts);

      // 2) Fetch cards for handles and append into swiper wrapper
      hydrateRecentlyViewedSection(sectionEl);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
